import SkeletonBox, { Props } from "./SkeletonBox";

const SkeletonText: React.FC<Props> = props => (
  <SkeletonBox h="10px" maxWidth="100px" my="7px" {...props} />
);

export default SkeletonText;
